//import axios from 'axios';
import axios, {API_URL} from '../utils/axios';
const API_URL_VERSION =API_URL + "/v1/admin/";

const getStats = ()=>{
    return axios.get(API_URL_VERSION+"dashboards");
}


export default {
    getStats,
}